import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { UrlService } from '../services/url.service';

/**
 * First-segment slugs that are real application routes and must never be
 * treated as an organization whitelabel slug.
 */
const RESERVED_SLUGS = ['sessions', 'organizacoes'];

/**
 * Camada A do whitelabel por organização.
 *
 * Captura o slug da organização no primeiro segmento da URL (`:organization/login`)
 * e redireciona para o login real preservando o slug como query param `nameUrlSafe`,
 * que é consumido pelo `OrganizationGuard` (Camada B) para buscar o whitelabel.
 */
@Injectable({
  providedIn: 'root',
})
export class OrganizationLoginGuard implements CanActivate {
  constructor(
    private router: Router,
    private urlService: UrlService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const organization = route.params['organization'];

    if (!organization || RESERVED_SLUGS.includes(organization)) {
      return true;
    }

    this.router.navigate([this.urlService.login()], {
      queryParams: { nameUrlSafe: organization },
      queryParamsHandling: 'merge',
    });
    return false;
  }
}
